import api from './api';

const activityService = {
  getAll: async (filters?: any) => {
    const response = await api.get('/activities', { params: filters });
    return response.data;
  },

  getRecent: async (limit: number = 10) => {
    const response = await api.get('/activities/recent', { params: { limit } });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/activities/stats');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get(`/activities/${id}`);
    return response.data;
  },
};

export default activityService;